


































































































import {Component} from '@/shared/component';
import {Contact} from '@/models';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';

import storeContact from '@/stores/modules/contact';

import CrudFournisseurShow from '@/components/Crud/Fournisseur/Show.vue';
import CrudFournisseurEdit from '@/components/Crud/Fournisseur/Edit.vue';

@Component({
	components: {
		CrudFournisseurShow,
		CrudFournisseurEdit,
	}
})
export default class CrudContactShow extends AbstractShowVue<Contact> {
	public constructor() {
		super(storeContact);
	}
}
